import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/LinkHandler.vue'),
        props: (route) => ({ 
            link_id: route.query.link_id,
            partner_code: route.query.partner_code
        })
    },
    {
        path: '/app',
        name: 'AppRedirect',
        component: () => import('@/views/AppRedirect.vue')
    },
    {
        path: '/error',
        name: 'Error',
        component: () => import('@/views/ErrorPage.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/error'
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router